import axios from 'axios'

export default {
  namespaced: true,

  state: {
    logs: {
      list: [],
      count: 0
    }
  },

  getters: {},

  mutations: {
    SET_SUPERADMIN_LOGS(state, data) {
      state.logs.list = data.list
      state.logs.count = data.count.total
    }
  },

  actions: {
    async list ({ commit }, { status, params }) {
      const response = await axios.get(`/admins/superadmin/${status}`, { params })
      commit('SET_SUPERADMIN_LOGS', response.data)
    }
  }
}
